import { useMediaQuery } from '@chakra-ui/react';
import useGetLocalStorage from './useGetLocalStorage';

export default function useMobileLayout() {
  const hasMobileLayout = useGetLocalStorage('mobile-layout');
  const [isLessThan560] = useMediaQuery('(max-width: 560px)');
  return isLessThan560 && hasMobileLayout;
}
